class AirwallexService {
  /**
   * Open the Hosted Payment Page for an intent returned by the
   * /merchant/checkout-hpp-airwallex-for-* endpoints.
   * Airwallex requires HPP to be launched through their JS SDK
   * (redirectToCheckout) rather than a hand-built URL — the page's own
   * route/params are internal to them and can change.
   * The SDK is imported on demand so it only loads when paying with Airwallex.
   * `env` belongs to init(), not redirectToCheckout(). No failUrl: Airwallex
   * deprecates it — a failed payment is retried on the HPP itself, and the
   * outcome is confirmed server-side (check-hpp / payment_intent.succeeded).
   * @param {Object} data { payment_intent_id, client_secret, currency, country_code, env, success_url }
   * @param {Function} [onBack] called when Back from the HPP restores this page
   *   from the browser's back/forward cache — the caller's loader is still up
   *   there, since the page was frozen mid-redirect.
   */
  async redirectToHpp(data, onBack) {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.removeEventListener('pageshow', handlePageShow);
        onBack();
      }
    };
    if (onBack) {
      window.addEventListener('pageshow', handlePageShow);
    }

    try {
      const { init } = await import('@airwallex/components-sdk');
      const { payments } = await init({
        env: data.env,
        enabledElements: ['payments'],
      });

      payments.redirectToCheckout({
        intent_id: data.payment_intent_id,
        client_secret: data.client_secret,
        currency: data.currency,
        country_code: data.country_code,
        successUrl: data.success_url,
      });
    } catch (error) {
      window.removeEventListener('pageshow', handlePageShow);
      throw error;
    }
  }
}

export default new AirwallexService();
